module.exports = __webpack_public_path__ + "img/flow3.89f2a162.png";